import Cookies from 'js-cookie';
import deleteForm from '../Form/deleteForm';
import { domain, reduxDataBases } from '../../config';
import deleteImages from '../Image/deleteImages';
import { recordManager } from '../../config/configuration/react';

export default async function clearDataLogout(localForms) {
  try {
    await deleteImages();
    await recordManager.clearRecordDb();
    indexedDB.deleteDatabase(reduxDataBases.vincheck);
    indexedDB.deleteDatabase('redux.offers');
    const promises = Object.values(localForms).map(async (value) => {
      if (value.buyerId !== 'undefined' && value.id !== undefined) {
        return deleteForm(value.id, true);
      }
      return false;
    });

    await Promise.all(promises);
    Object.keys(localStorage).forEach((key) => {
      if (key !== 'translation') localStorage.removeItem(key);
    });
    Object.entries(Cookies.get()).forEach(([key]) => {
      if (!['didomi_token', 'popUpLastSeen'].includes(key) && !key.startsWith('dontShowTradePopup_')) {
        Cookies.remove(key, { domain, path: '/' });
      }
    });
    Object.keys(Cookies.get()).forEach((key) => {
      if (key.startsWith('zs_popup_') || key.includes('zoho')) {
        Cookies.remove(key, { domain, path: '/' });
      }
    });
    document.cookie = 'zs_popup_1dBa7i?az_mail=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    return 'success';
  } catch (e) {
    throw new Error('fail deleting data for logout !');
  }
}
